
import SectionContactAdvert from "./contact-advert";
import SectionContactForm from "./contact-form";
const SectionContactForm2 = () => {
    
    return (
       <div className="section-full p-b90 site-bg-white">
                <div className="container">
                    <div className="section-content">
                       
                        <div className="av-contact-fm-section wow fadeInDown" data-wow-delay="0.2">
                            <div className="row">
                                <div className="col-lg-8 col-md-7 m-b30">
                                    <SectionContactForm />
                                </div>
                                <div className="col-lg-4 col-md-5 m-b30">
                                    <SectionContactAdvert />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default SectionContactForm2;